import React, { useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import {
  ListServers,
  ServerForm,
} from "../../../../components/Admin/Educasimulator";
import "./Servers.scss";

export function Servers() {
  const [reload, setReload] = useState(false);
  const [open, setOpen] = useState(false);

  const onReload = () => setReload((prev) => !prev);
  const onOpenClose = () => setOpen((prev) => !prev);

  return (
    <div className="servers-page">
      <div className="servers-page__header">
        <h1>Servidores de Simuladores</h1>
        <Button primary icon labelPosition="left" onClick={onOpenClose}>
          <Icon name="add" /> Crear servidor
        </Button>
      </div>

      <ListServers reload={reload} onReload={onReload} />

      <BasicModal show={open} close={onOpenClose} title="Crear servidor">
        <ServerForm onClose={onOpenClose} onReload={onReload} />
      </BasicModal>
    </div>
  );
}
